import i18n from "src/i18n/config";
import { z } from "zod";

const usernameMaxLength = 250;
const passwordMinLength = 8;
const passwordMaxLength = 250;

// Printable ASCII without spaces — credentials are passed in a URL.
const credentialsCharsetRegex = /^[!-~]+$/;

/**
 * The charset check comes first on purpose. `useValidationSchema` keeps the last error per field,
 * so this order shows the length hint for a short value and the charset hint only for bad characters.
 */
export const setBwcCredentialsValidationSchema = z
    .object({
        username: z
            .string(i18n.t("common:validation.fieldRequired"))
            .regex(credentialsCharsetRegex, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.usernameCharset"))
            .min(1, i18n.t("common:validation.fieldRequired"))
            .max(usernameMaxLength, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.usernameMax")),
        password: z
            .string(i18n.t("common:validation.fieldRequired"))
            .regex(credentialsCharsetRegex, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.passwordCharset"))
            .min(passwordMinLength, i18n.t("common:validation.custom.passwordMin"))
            .max(passwordMaxLength, i18n.t("sidepanels:devicePanel.bwcTab.credentials.validation.passwordMax")),
        passwordRepeat: z.string(i18n.t("common:validation.fieldRequired")).min(1, i18n.t("common:validation.fieldRequired")),
    })
    .refine((values) => values.password === values.passwordRepeat, {
        message: i18n.t("common:validation.passwordMatch"),
        path: ["passwordRepeat"],
    });
